/* eslint max-classes-per-file: 0 */
/* eslint class-methods-use-this: 0 */

import { RegisterModule } from '@/typings/common'
import {
  DashboardLogin,
  DashboardSession,
  DashboardAsyncTask,
} from '@/typings/api/Dashboard'

import {
  registerModule as vuexRegisterModule,
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper,
} from 'vuex-smart-module'
import { MonitoringDashboardsApiAuth, AsyncTaskDashboardsApi } from '@/api/resources'
import { MODULE_NAME } from './utils'


type S = DashboardAuthState
type G = DashboardAuthGetters
type M = DashboardAuthMutations
type A = DashboardAuthActions

class DashboardAuthState {
  public logins: DashboardLogin[] = [];

  public sessions: DashboardSession[] = [];

  public asyncTasks: DashboardAsyncTask[] = [];
}

class DashboardAuthGetters extends Getters<S> {
}

class DashboardAuthMutations extends Mutations<S> {
  public setLogins(payload: DashboardLogin[]) {
    this.state.logins = payload
  }

  public setSessions(payload: DashboardSession[]) {
    this.state.sessions = payload
  }

  public setAsyncTasks(payload: DashboardAsyncTask[]) {
    this.state.asyncTasks = payload
  }

  public logout() {
    this.state.logins = []
    this.state.sessions = []
    this.state.asyncTasks = []
  }
}

class DashboardAuthActions extends Actions<S, G, M, A> {
  private readonly dashboardsApi = new MonitoringDashboardsApiAuth();

  private readonly asyncTaskDashboardsApi = new AsyncTaskDashboardsApi();

  public async getLogins() {
    const { data } = await this.dashboardsApi.getLogins()
    if (data) this.mutations.setLogins(data)
    return this.state.logins
  }

  public async getSessions() {
    const { data } = await this.dashboardsApi.getSessions()
    if (data) this.mutations.setSessions(data)
    return this.state.sessions
  }

  public async getAsyncTasks() {
    const { data } = await this.asyncTaskDashboardsApi.getAsyncTasks()
    if (data) this.mutations.setAsyncTasks(data)
    return this.state.asyncTasks
  }

  public async runAsyncTask(name: string) {
    await this.asyncTaskDashboardsApi.runAsyncTask({ name })
    // После запуска задачи, ее статус обновится не раньше, чем через 5 секунд.
    await new Promise((resolve) => setTimeout(resolve, 6000))
    await this.dispatch('getAsyncTasks')
  }

  private readonly logout = {
    root: true,
    handler(this: DashboardAuthActions) {
      return this.mutations.logout()
    },
  };
}

const storeModule = (
  new Module({
    state: DashboardAuthState,
    getters: DashboardAuthGetters,
    mutations: DashboardAuthMutations,
    actions: DashboardAuthActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as dashboardAuthStoreModule,
  mapper as dashboardAuthMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
